module.exports = __webpack_public_path__ + "static/glitter-jewellers-logo-min-1cf8700e724a6ff2d8a17219dfda9b93.png";